<template>
<div class="detail-wrapper">
  <div class="detail-content">
    <!-- 订单基本信息 -->
    <div class="detail-card">
      <div class="card-header">
        <div class="header-title">基本信息</div>
      </div>
      
      <div class="info-list">
        <div class="info-item">
          <div class="info-label">预约编号</div>
          <div class="info-value">{{detail.yybh}}</div>
        </div>
        
        <div class="info-item">
          <div class="info-label">车头号</div>
          <div class="info-value">{{detail.chetouhao}}</div>
        </div>
        
        <div class="info-item">
          <div class="info-label">车挂号</div>
          <div class="info-value">{{detail.cheguahao}}</div>
        </div>
        
        <div class="info-item">
          <div class="info-label">预约时间</div>
          <div class="info-value">{{detail.createDate}}</div>
        </div>
        
        <div class="info-item">
          <div class="info-label">时间段</div>
          <div class="info-value">{{detail.pdsjd}}</div>
        </div>
        
        <div v-if="(detail.txhlb) == '提货'" class="info-item">
          <div class="info-label">提货口</div>
          <div class="info-value">{{detail.thk}}</div>
        </div>
        
        <div class="info-item">
          <div class="info-label">司机</div>
          <div class="info-value">{{detail.createName}}</div>
        </div>
        
        <div class="info-item">
          <div class="info-label">起始时间</div>
          <div class="info-value">{{detail.yyqssj}}</div>
        </div>
        
        <div class="info-item">
          <div class="info-label">终止时间</div>
          <div class="info-value">{{detail.yyzzsj}}</div>
        </div>
        
        <div v-show="(sysVersion =='NEW')" class="info-item">
          <div class="info-label">预约数量</div>
          <div class="info-value">{{(detail.yuzuoyesl?detail.yuzuoyesl:0)+' 吨（T）'}}</div>
        </div>
      </div>
    </div>
    
    <!-- 提货/卸货信息 -->
    <div v-if="detail.ltxtCcpdYyfbList && detail.ltxtCcpdYyfbList.length > 0" class="detail-card">
      <div class="card-header">
        <div class="header-title">{{(detail.txhlb) == '提货' ? '提货信息' : '卸货信息'}}</div>
      </div>
      
      <div v-for="item in detail.ltxtCcpdYyfbList" :key="item.id" class="sub-card">
        <div class="sub-card-header">订单编号: {{item.fhtzdh}}</div>
        
        <div class="info-list">
          <div class="info-item">
            <div class="info-label">客户通知单号</div>
            <div class="info-value">{{item.khtzdh}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">{{(detail.txhlb) == '提货' ? '提货单位' : '卸货单位'}}</div>
            <div class="info-value">{{item.thdw}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">品种</div>
            <div class="info-value">{{item.pinzhong}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">合同号</div>
            <div class="info-value">{{item.hth}}</div>
          </div>
          
          <div v-show="(sysVersion =='OLD')" class="info-item">
            <div class="info-label">重量</div>
            <div class="info-value">{{item.tzsl}}</div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 二维码 -->
    <div class="detail-card" style="margin-bottom: 150px;">
      <div class="card-header">
        <div class="header-title">二维码</div>
      </div>
      <div class=" qrcode-card">
        <div class="company-name">{{detail.sysCompanyCode}}</div>
        <div id="qrcode" class="qrcode"></div>
      </div>
    </div>
  </div>

  
  <!-- 底部按钮 -->
  <div class="footer-actions" v-if="detail.sfky == 'Y'">
    <van-button 
      type="primary" 
      block 
      class="action-btn advance-btn" 
      @click="advanceAppointment"
    >
      <van-icon name="arrow-left" /> 预约提前
    </van-button>
    
    <van-button 
      type="primary" 
      block 
      class="action-btn delay-btn" 
      @click="delayAppointment"
    >
      预约延后 <van-icon name="arrow" />
    </van-button>
  </div>
  
  <Tabbar></Tabbar>
</div>
</template>

<script>
import api from '@/fetch/api'
import axios from 'axios'
import QRCode from 'qrcodejs2-fix'
import {
  Toast,Dialog
} from 'vant';
import Tabbar from '../Public/tabbarTpl.vue'
export default {
  components: {
    Tabbar
  },
  inject: ['reload'],
  data() {
    return {
      id: "",
      detail: [],
      sysVersion:"OLD",
      appointmentTime:20,
    }
  },
  created() {
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getOrderDetail(id);
    document.title = "订单详情";
    this.getSysInfo();
    this.fetchFileContent();
  },
  methods: {
    async fetchFileContent() {
      try {
        const response = await axios.get('/appointmentTime.txt?time='+this.generateRandomDateTimeWithNumber());
        console.log('/appointmentTime.txt?time='+this.generateRandomDateTimeWithNumber());
        this.appointmentTime = response.data;
      } catch (error) {
        console.error('Error fetching file:', error);
      }
    },
    getOrderDetail(id) {
      var that = this;
      api.getOrderDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          that.$data.detail = detail;

          var yybh = res.data.yybh;
          that.qrcode(yybh);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    qrcode(yybh) {
      if(yybh)
      {
        document.getElementById('qrcode').textContent = ''
        new QRCode('qrcode', {
          text: yybh // 二维码内容
        })
      }
    },
    //获取系统信息
    getSysInfo()
    {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      //获取系统信息
      api.getSysInfo(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var sysVersion = res.data.sysVersion;
          that.sysVersion = sysVersion;
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },
    //预约提前
    advanceAppointment()
    {
      var yybh = this.detail.yybh;
      var chetouhao = this.detail.chetouhao;
      if(yybh.length>0 && chetouhao.length>0)
      {
        Dialog.confirm({
          message: '是否要将预约提前'+this.appointmentTime+'分钟',
        })
          .then(() => {
            // on confirm
            this.postadjustyy(yybh,chetouhao,2);
          })
          .catch(() => {
            // on cancel
          });
      }
      else{
        Toast.fail('参数异常');
      }
    },
    //延后预约
    delayAppointment()
    {
      var yybh = this.detail.yybh;
      var chetouhao = this.detail.chetouhao;

      if(yybh.length>0 && chetouhao.length>0)
      {
        Dialog.confirm({
          message: '是否要将预约延后'+this.appointmentTime+'分钟',
        })
          .then(() => {
            this.postadjustyy(yybh,chetouhao,1);
          })
          .catch(() => {
            // on cancel
          });
      }
      else{
        Toast.fail('参数异常');
      }
    },
    generateRandomDateTimeWithNumber() {
      // 获取当前日期时间
      const now = new Date();

      // 提取年月日时分秒
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      // 拼接日期时间字符串
      const dateTimeString = `${year}${month}${day}${hours}${minutes}${seconds}`;

      // 生成4位随机数
      const randomNumber = Math.floor(1000 + Math.random() * 9000).toString().padStart(4, '0');

      // 返回最终的字符串
      return `${dateTimeString}${randomNumber}`;
    },
    postadjustyy(yybh,chetouhao,czlx)
    {
      var that = this;
      console.log('yybh',yybh.length);
      console.log('chetouhao',chetouhao.length);
      if(yybh.length>0 && chetouhao.length>0 && czlx)
      {
        console.log('123');
        let formData = new FormData();
        formData.append("yybh", yybh);
        formData.append("chetouhao", chetouhao);
        formData.append("czlb", czlx);
        api.postadjustyy(formData).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            if(czlx == 1)
            {
              // on confirm
              Dialog.alert({
                message: '延后成功，请规划好您的时间入场，避免爽约',
              }).then(() => {
                // on close
                that.reload();
              });
            }
            else if (czlx == 2) {
              Dialog.alert({
                message: '提前成功，请规划好您的时间入场，避免爽约',
              }).then(() => {
                // on close
                that.reload();
              });
            }
          }
          else{
            Toast.fail(res.message);
          }
        }).catch(function(err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        });
      }
      else{
        Toast.fail('参数异常');
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.detail-wrapper {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 60px;
}

.detail-content {
  padding: 12px;
}

.detail-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  .card-header {
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6f7;
    
    .header-title {
      font-size: 16px;
      font-weight: 600;
      color: #323233;
      position: relative;
      padding-left: 10px;
      
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #4080ff;
        border-radius: 2px;
      }
    }
  }
  
  .info-list {
    padding: 12px 16px;
  }
  
  .info-item {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #f5f6f7;
    
    &:last-child {
      border-bottom: none;
    }
    
    .info-label {
      width: 90px;
      font-size: 14px;
      color: #969799;
    }
    
    .info-value {
      flex: 1;
      font-size: 14px;
      color: #323233;
      font-weight: 500;
    }
  }
  
  .sub-card {
    margin-top: 8px;
    border-top: 1px solid #f5f6f7;
    
    .sub-card-header {
      padding: 12px 16px;
      font-size: 14px;
      font-weight: 600;
      color: #323233;
      background-color: #f7f8fa;
    }
  }
}

.qrcode-card {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 60px;
  
  .company-name {
    font-size: 16px;
    color: #323233;
    margin-bottom: 20px;
    font-weight: 500;
  }
  
  .qrcode {
    width: 50vw;
    height: 50vw;
    
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.footer-actions {
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  display: flex;
  padding: 10px 12px;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 10;
  
  .action-btn {
    flex: 1;
    margin: 0 6px;
    height: 44px;
    border-radius: 8px;
    
    &.advance-btn {
      background-color: #4080ff;
      border: none;
    }
    
    &.delay-btn {
      background-color: #ff9d00;
      border: none;
    }
  }
}
</style>

<style lang="css" scoped>
.qrcode >>> img {
  width: 50vw;
  height: 50vw;
}
.qrcode >>> canvas {
  width: 50vw !important;
  height: 50vw !important;
}
</style>
